module.exports = __webpack_public_path__ + "static/media/Home Page_website-07.2c601e6c.png";